import React from "react";
import { useAuthStore } from "../../../store";

function useAuthUser() {
  const authUser = useAuthStore((state) => state.user);
  return React.useMemo(() => authUser, [authUser]);
}

export default useAuthUser;
